import type { ActiveChat } from '@/app/(protected)/[workspace_slug]/chat/ChatContext';
import type { ChatConversationType } from '@/features/chat/types';

const CHAT_CONVERSATION_TYPES = new Set<ChatConversationType>([
  'stream',
  'general_channel',
  'job_channel',
  'direct_message',
  'unread',
  'mentions',
]);

export function getChatFromSearchParams(
  searchParams: URLSearchParams,
): ActiveChat | null {
  const type = searchParams.get('conversation_type') as ChatConversationType;
  const id = searchParams.get('conversation_id');

  if (!type || !id || !CHAT_CONVERSATION_TYPES.has(type)) {
    return null;
  }

  return {
    id,
    type,
    title: searchParams.get('conversation_title') || 'Chat',
    description: searchParams.get('conversation_description') || undefined,
    jobId: searchParams.get('job_id') || undefined,
    isReadOnly: searchParams.get('is_read_only') === 'true',
    isArchived: searchParams.get('is_archived') === 'true',
  };
}

export function getChatSearchParams(chat: ActiveChat) {
  const nextParams = new URLSearchParams();

  nextParams.set('conversation_type', chat.type);
  nextParams.set('conversation_id', chat.id);
  nextParams.set('conversation_title', chat.title);

  if (chat.description) {
    nextParams.set('conversation_description', chat.description);
  }

  if (chat.jobId) {
    nextParams.set('job_id', chat.jobId);
  }

  if (chat.isReadOnly) {
    nextParams.set('is_read_only', 'true');
  }

  if (chat.isArchived) {
    nextParams.set('is_archived', 'true');
  }

  return nextParams;
}

export function isSameActiveChat(first: ActiveChat, second: ActiveChat) {
  return (
    first.id === second.id &&
    first.type === second.type &&
    first.title === second.title &&
    first.description === second.description &&
    first.jobId === second.jobId &&
    first.isReadOnly === second.isReadOnly &&
    first.isArchived === second.isArchived
  );
}
